module.exports = __webpack_public_path__ + "img/uploadFile.532d2c39.svg";